import { render } from "./Gifts.vue?vue&type=template&id=306aa9a8&scoped=true"
import script from "./Gifts.vue?vue&type=script&lang=js"
export * from "./Gifts.vue?vue&type=script&lang=js"

import "./Gifts.vue?vue&type=style&index=0&id=306aa9a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306aa9a8"]])

export default __exports__